<template>
  <Card class="container-detail" shadow>
    <InspectModal ref="InspectModal"></InspectModal>
    <ContainerLogs ref="ContainerLogs"></ContainerLogs>
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'container'})">返回列表</Button>
      </div>
    </Row>
    <div class="content">
      <div class="main">
        <div>
          <Row style="margin-bottom: 10px">
            <Col :xs="24" :sm="24" :md="24" :lg="15">
              <div style="padding-bottom: 15px">
                <Row class="title">
                  <h4 :style="{float: 'left'}">容器详情</h4>
                  <div style="padding-right: 10px; float: right">
                    <Button style="margin-right: 8px" type="info" size="small" ghost @click="$refs.InspectModal.showModal($route.params.id, $route.params.nodeId)">
                      <span>Inspect</span>
                    </Button>
                    <Button style="margin-right: 8px" type="info" size="small" ghost @click="$refs.ContainerLogs.getLogs($route.params.id, $route.params.nodeId)">
                      <Icon type="iconfont icon-log" style="font-family: iconfont"/>
                      <span> 日志</span>
                    </Button>
                    <ActionMenu :container="info" v-on:callback="actionCallback"></ActionMenu>
                  </div>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else :style="{borderTopColor: color, borderTopWidth: '2px'}">
                  <dl>
                    <dt>容器名称</dt><dd>{{ info.Name.startsWith('/') ? info.Name.substr(1) : info.Name }}</dd>
                  </dl>
                  <dl>
                    <dt>容器ID</dt><dd>{{ info.Id }}</dd>
                  </dl>
                  <dl>
                    <dt>指令</dt>
                    <dd v-if="info.Config">
                      <span v-for="(item, index) in info.Config.Cmd" :key="index">{{ item }} </span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>镜像</dt>
                    <dd>{{ info.Config ? info.Config.Image : info.Image }}</dd>
                  </dl>
                  <dl>
                    <dt>状态</dt>
                    <dd v-if="info.State">
                      <span v-if="info.State.Status === 'running'">
                        <span style="font-weight: bold" :style="{color: color}">Up </span>
                        <Time :time="info.State.StartedAt" :interval="60" style="color: #999"/>
                        <span v-if="info.State.Health">
                          <span style="font-weight: bold" :style="{color: '#19be6b'}"
                                v-if="info.State.Health.Status === 'healthy'"> ({{ info.State.Health.Status }})</span>
                          <span style="font-weight: bold" :style="{color: '#ed4014'}"
                                v-else-if="info.State.Health.Status === 'unhealthy'"> ({{ info.State.Health.Status }})</span>
                          <span style="font-weight: bold" :style="{color: '#ff9900'}"
                                v-else> ({{ info.State.Health.Status }})</span>
                        </span>
                      </span>
                      <span v-else-if="info.State.Status === 'paused'">
                        <span style="font-weight: bold" :style="{color: color}">Up </span>
                        <Time :time="info.State.StartedAt" :interval="60" style="color: #999"/>
                        <span style="font-weight: bold" :style="{color: color}"> (paused)</span>
                      </span>
                      <span v-else-if="info.State.Status === 'exited'">
                        <span style="font-weight: bold" :style="{color: color}">Exited ({{ info.State.ExitCode }}) </span>
                        <Time :time="info.State.FinishedAt" :interval="60" style="color: #999"/>
                      </span>
                      <span v-else>
                        <span style="font-weight: bold" :style="{color: color}">{{ info.State.Status }}</span>
                      </span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>创建时间</dt>
                    <dd v-if="info.Created">{{ moment(info.Created).format('YYYY-MM-DD HH:mm:ss') }} （<Time :time="info.Created" :interval="60"/>）</dd>
                  </dl>
                  <dl>
                    <dt>端口映射</dt>
                    <dd v-if="info.NetworkSettings">
                    <span v-for="(value, key, itemIndex) in info.NetworkSettings.Ports" :key="`item_${itemIndex}`">
                      <p v-for="(pItem, pItemIndex) in value" :key="`pItem_${pItemIndex}`">{{ pItem.HostIp }}:{{ pItem.HostPort }} -> {{ key }}</p>
                    </span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>目录映射</dt>
                    <dd v-if="info.Mounts">
                      <span v-for="(item, itemIndex) in info.Mounts" :key="`item_${itemIndex}`">
                        <p>{{ item.Source }}:{{ item.Destination }}{{ item.Mode ? `:${item.Mode}` : '' }}</p>
                      </span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>环境变量</dt>
                    <dd v-if="info.Config">
                      <p v-for="(item, index) in info.Config.Env" :key="index">{{ item }}</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>节点名称</dt><dd v-if="info.node">{{ info.node.name }}</dd>
                  </dl>
                  <dl>
                    <dt>节点主机</dt><dd>{{ info.node.url }}</dd>
                  </dl>
                </div>
              </div>
              <Row class="title">
                <h4 :style="{float: 'left'}">进程</h4>
              </Row>
              <Top ref="Top" :container-id="$route.params.id" :node-id="$route.params.nodeId"></Top>
            </Col>
            <Col :md="{ span: 6, offset: 1 }">
              <div class="title" >
                <h4>操作日志</h4>
              </div>
              <OperateLogs :logs="info.operate_logs" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { detailContainers } from '@/api/container/container'
import moment from 'moment'
import ActionMenu from './components/ActionMenu'
import Top from './components/top'
import ContainerLogs from './components/containerLogs'
import OperateLogs from '../components/operateLogs'
import InspectModal from './components/inspect'

export default {
  name: 'detail',
  components: {
    ActionMenu,
    ContainerLogs,
    OperateLogs,
    Top,
    InspectModal
  },
  data () {
    return {
      infoError: false,
      info: {},
      moment: moment,
      color: '#D4D6D8'
    }
  },
  '$route' () {
    if (this.$route.params.id && this.$route.params.nodeId) {
      this.getInfo()
    }
  },
  created: function () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      detailContainers(this.$route.params.id, this.$route.params.nodeId).then(res => {
        this.info = res.data
        this.infoError = false
        if (this.info.State) {
          if (this.info.State.Status === 'running') {
            this.color = '#19be6b'
          } else if (this.info.State.Status === 'paused') {
            this.color = '#ff9900'
          } else {
            this.color = '#ed4014'
          }
        }
      }).catch(res => {
        this.infoError = true
        console.log(res.response)
      })
    },
    actionCallback () {
      this.getInfo()
      this.$refs.Top.getTop()
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  @media screen and (max-width:768px){
    .container-detail{
      .ivu-col{
        position:initial;
      }
      .content .main .info-property dl dt{
        width:90px;
      }
      .content .main .title h4{
        display: table;
        margin-top:0;
      }
      .ivu-table{
        margin-bottom: 20px;
      }
    }
  }
</style>
